<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0 auth-bg d-flex justify-content-center">
      <!-- <b-col lg="8" class="d-none d-lg-flex align-items-center p-0">
        <div class="w-100 d-lg-flex">
          <b-img :src="imgUrl" alt="Login V2" style="height: 100vh" />
        </div>
      </b-col> -->
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="5"
        cols="12"
        xl="4"
        md="12"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title
            class="mb-1 font-weight-bold text-center"
            title-tag="h2"
          >
            ログイン
          </b-card-title>

          <!-- form -->
          <validation-observer ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group label="メールアドレス" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="Email"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">パスワード</label>
                  <!-- <b-link :to="{ name: 'auth-forgot-password' }">
                    <small>パスワードを忘れた場合</small>
                  </b-link> -->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <small class="text-danger">{{ apiError }}</small>
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                ログイン
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <!-- <span>New on our platform? </span> -->
            <b-link :to="{ name: 'auth-register' }">
              <span>&nbsp;アカウント作成</span>
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";

import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from "bootstrap-vue";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { required, email } from "@validations";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";

import store from "@/store/index";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      apiError: "",
      status: "",
      password: "",
      userEmail: "",
      sideImg: require("@/assets/images/pages/loginbg.jpg"),

      // validation rules
      required,
      email,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/loginbg.jpg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    login() {
      this.apiError = "";
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          // console.log("this.userEmail", this.userEmail);
          useJwt
            .login({
              userName: this.userEmail,
              password: this.password,
            })
            .then((response) => {
              let dataResponse = response.data.data;
              let userData = {
                userName: dataResponse.user.userName,
                role: "admin",
                ability: [
                  {
                    action: "manage",
                    subject: "all",
                  },
                ],
              };

              if (dataResponse.user.isRoleAdmin == false) {
                userData.role = 'user';
                userData.ability = [
                  {
                    action: "read",
                    subject: "all",
                  },
                ];
              }

              useJwt.setToken(response.data.data.accessToken);
              useJwt.setRefreshToken(response.data.data.refreshToken);
              localStorage.setItem("userData", JSON.stringify(userData));
              this.$ability.update(userData.ability);

              // ? This is just for demo purpose as well.
              // ? Because we are showing eCommerce app's cart items count in navbar
              // this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', userData.extras.eCommerceCartItemsCount)

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$router
                .replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: `${userData.userName}さん、ようこそ！`,
                      icon: "CoffeeIcon",
                      variant: "success",
                      // text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                    },
                  });
                });
            })
            .catch((error) => {
              this.apiError = error.response.data.message;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
